import { Stack, Typography } from '@mui/joy';
import { Link } from 'react-router-dom';
import { useUser } from '../../../hooks/useUser';
import NewLogo from '../logo_new.png';

export function DynamicLogo() {
  const userQuery = useUser();

  if (!userQuery.isSuccess) {
    return null;
  }

  return (
    <Link to="/">
      <Stack sx={{ position: 'relative' }}>
        <img src={NewLogo} alt="ScConnect Logo" className="w-32 lg:w-48"></img>
        <Typography
          level="body-xs"
          sx={{
            position: 'absolute',
            right: 0,
            bottom: -8,
          }}
        >
          {userQuery.data.branch}
        </Typography>
      </Stack>
    </Link>
  );
}
